export const PROFILE_TEST_IDS = {
  PAGE: 'profile-page',
  TIMEZONE_SELECT: 'profile-timezone-select',
  PROVIDER_DROPDOWN: 'profile-provider-dropdown',
  THEME_LIGHT_BTN: 'profile-theme-light-btn',
  THEME_DARK_BTN: 'profile-theme-dark-btn',
  THEME_SYSTEM_BTN: 'profile-theme-system-btn',
  PALETTE_VIEW_SELECT: 'profile-palette-view-select',
  PRESET_BTN: (name: string) => `profile-preset-btn-${name.toLowerCase()}`,
} as const;
